import { createI18n } from "vue-i18n"

import fr from "./locales/fr"
import en from "./locales/en"


const getDefaultLanguage = () => {
  // 1. Vérifier si l'utilisateur a déjà choisi une langue
  const savedLang = localStorage.getItem("lang")

  if (savedLang) {
    return savedLang
  }

  // 2. Récupérer la langue du navigateur/device
  const deviceLang = navigator.language.split("-")[0]

  // 3. Vérifier si la langue est supportée
  if (["fr", "en"].includes(deviceLang)) {
    return deviceLang
  }

  // 4. Langue par défaut
  return "fr"
}


const i18n = createI18n({
  legacy: false,
  globalInjection: true,

  locale: getDefaultLanguage(),

  fallbackLocale: "fr",

  messages: {
    fr,
    en,
  },
})


export default i18n